export const ENTER_NAME = 'Enter';
export const ESC_NAME = 'Escape';
export const NUMPAD_ENTER_NAME = 'NumpadEnter';
